import React, { useState } from 'react';
import { B } from '../constants';
import PlatformShareModal from './PlatformShareModal';
import FollowButton from './FollowButton';

export default function PromoCard({ promo, onClick, currentUser, followingIds = [], onFollowUpdate }) {
  const isInfluencer = promo.user?.isInfluencer;
  const isFollowing = followingIds.includes(promo.user?.id);
  const isOwn = currentUser?.id === promo.user?.id;
  const [showShare, setShowShare] = useState(false);

  return (
    <>
      <div onClick={onClick} style={{ breakInside: 'avoid', marginBottom: 20, borderRadius: 20, background: 'white', overflow: 'hidden', cursor: 'pointer', boxShadow: '0 4px 16px rgba(0,0,0,0.08)', transition: 'all 0.25s', animation: 'fadeUp 0.4s ease' }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.15)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)';   e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; }}>

        <div style={{ position: 'relative', paddingTop: '120%', background: `linear-gradient(135deg,${B.night},#1a3a2a)`, overflow: 'hidden' }}>
          {promo.thumbnailUrl && <img src={promo.thumbnailUrl} alt={promo.title || 'Promo thumbnail'} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />}

          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.2)' }}>
            <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'rgba(255,255,255,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>▶️</div>
          </div>

          <div style={{ position: 'absolute', top: 12, left: 12, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {isInfluencer && (
              <span style={{ background: `linear-gradient(135deg,${B.amber},#ff6b35)`, color: 'white', fontSize: 10, fontWeight: 800, padding: '3px 10px', borderRadius: 20, fontFamily: "'Montserrat',sans-serif" }}>✨ CREATOR</span>
            )}
            {promo.destination && (
              <span style={{ background: 'rgba(0,0,0,0.55)', color: 'white', fontSize: 10, fontWeight: 600, padding: '3px 10px', borderRadius: 20, fontFamily: "'Montserrat',sans-serif" }}>📍 {promo.destination}</span>
            )}

          </div>

          <div style={{ position: 'absolute', top: 12, right: 12, background: B.night, color: 'white', fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 20, fontFamily: "'Montserrat',sans-serif" }}>
            ⏱ {promo.timeLeft}
          </div>

          <div style={{ position: 'absolute', bottom: 12, left: 12, color: 'white', fontSize: 11, fontFamily: "'Montserrat',sans-serif", fontWeight: 600, display: 'flex', gap: 10 }}>
            <span>👁 {promo.views}</span>
            <span>❤️ {promo.likeCount}</span>
          </div>

          <button onClick={e => { e.stopPropagation(); setShowShare(true); }}
            style={{ position: 'absolute', bottom: 12, right: 12, background: 'rgba(0,0,0,0.5)', border: 'none', color: 'white', width: 32, height: 32, borderRadius: '50%', cursor: 'pointer', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            ↗️
          </button>
        </div>

        <div style={{ padding: '14px 16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: `linear-gradient(135deg,${B.forest},${B.mint})`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
                {promo.thumbnailUrl
                  ? <img src={promo.thumbnailUrl} alt={`${promo.user?.name || 'User'} avatar`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : <span style={{ color: 'white', fontSize: 11, fontWeight: 800 }}>{promo.user?.name?.[0]}</span>
                }
              </div>
              <span style={{ fontFamily: "'Montserrat',sans-serif", fontSize: 12, fontWeight: 700, color: B.muted }}>{promo.user?.name}</span>
            </div>
            {currentUser && !isOwn && (
              <FollowButton userId={promo.user?.id} initialFollowing={isFollowing} size="sm" onUpdate={() => onFollowUpdate?.()} />
            )}
          </div>
          <h4 style={{ fontFamily: "'Playfair Display',serif", fontSize: 16, fontWeight: 700, lineHeight: 1.3, marginBottom: 4 }}>{promo.title}</h4>
          {promo.caption && <p style={{ fontFamily: "'Montserrat',sans-serif", fontSize: 12, color: B.muted, lineHeight: 1.5, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{promo.caption}</p>}
        </div>
      </div>

      {showShare && (
        <PlatformShareModal promo={promo} user={currentUser} onClose={() => setShowShare(false)} />
      )}
    </>
  );
}
